import { gql } from '@apollo/client';

export const GET_MODES_PAGINATION = gql`
  query GetModesPagination(
    $filter: ReservationModeFilter!
    $page: Int!
    $perPage: Int!
  ) {
    schedule {
      reservationModePagination(
        filter: $filter
        page: $page
        perPage: $perPage
      ) {
        pageInfo {
          totalItems
          page
          perPage
          totalPages
          hasNextPage
          hasPreviousPage
        }
        items {
          id
          name
          duration
        }
      }
    }
  }
`;
